/** Site-scoped in-memory cache for non-financial account catalog data. Not wallet. */

export const ACCOUNT_CACHE_TTL_MS = 60000;

const store = new Map();
const inflight = new Map();

export function depositMethodsCacheKey({ siteId = '', currency = '' } = {}) {
  return ['deposit-methods', String(siteId || ''), String(currency || '')].join('|');
}

export function withdrawMethodsCacheKey({ siteId = '' } = {}) {
  return ['withdraw-methods', String(siteId || '')].join('|');
}

/** Unexpired catalog or null on miss. Empty array is a valid cached assignment. */
export function readCachedWithdrawMethods(siteId = '') {
  const hit = readAccountCache(withdrawMethodsCacheKey({ siteId }));
  return Array.isArray(hit) ? hit : null;
}

export function shouldApplyWithdrawMethodsResult({
  mounted = true,
  requestId,
  currentRequestId,
} = {}) {
  if (mounted === false) return false;
  if (requestId !== currentRequestId) return false;
  return true;
}

export function promotionsCacheKey({ siteId = '', placement = '' } = {}) {
  return ['promotions', String(siteId || ''), String(placement || '')].join('|');
}

export function readAccountCache(key) {
  const hit = store.get(key);
  if (!hit) return null;
  if (Date.now() > hit.expiresAt) {
    store.delete(key);
    return null;
  }
  return hit.value;
}

export function writeAccountCache(key, value, ttlMs = ACCOUNT_CACHE_TTL_MS) {
  store.set(key, { value, expiresAt: Date.now() + Number(ttlMs || ACCOUNT_CACHE_TTL_MS) });
}

export function isAccountAbortError(err) {
  if (!err) return false;
  if (err.name === 'AbortError') return true;
  const msg = String(err.message || err);
  return /aborted|AbortError/i.test(msg);
}

export function dedupeAccountFetch(key, producer) {
  const existing = inflight.get(key);
  if (existing) return existing;
  const pending = Promise.resolve()
    .then(producer)
    .finally(() => {
      if (inflight.get(key) === pending) inflight.delete(key);
    });
  inflight.set(key, pending);
  return pending;
}

export function __resetAccountCatalogForTests() {
  store.clear();
  inflight.clear();
}
